/**
 * Reduced-motion awareness for gestures.
 *
 * When the user requests reduced motion we still let them swipe (the gesture is
 * a primary interaction in the POS / KDS, not decoration) but we collapse the
 * commit/cancel transitions to ~0ms so the surface snaps instead of sliding.
 * Centralised so every gesture consumer treats the preference identically.
 */

/** True if the OS / browser reports `prefers-reduced-motion: reduce`. */
function prefersReducedMotion(): boolean {
  // eslint-disable-next-line lingui/no-unlocalized-strings -- CSS media query, not UI
  const mql = globalThis.matchMedia?.("(prefers-reduced-motion: reduce)");
  return mql?.matches ?? false;
}

/** Collapse an animation duration to 0 when reduced motion is requested. */
export function motionDurationMs(ms: number): number {
  return prefersReducedMotion() ? 0 : ms;
}
